import { ConfirmDialog } from '@/components/common/ConfirmDialog';
import { useDeleteCredential } from '@/hooks/useCredentials';

interface Props {
  credentialId: string;
  label: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function DeleteCredentialDialog({ credentialId, label, open, onOpenChange }: Props) {
  const { mutate: remove, isPending } = useDeleteCredential();

  function handleConfirm() {
    remove(credentialId, { onSuccess: () => onOpenChange(false) });
  }

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Excluir credencial"
      description={`Tem certeza que deseja excluir "${label}"? Esta ação não pode ser desfeita.`}
      confirmLabel="Excluir"
      variant="destructive"
      onConfirm={handleConfirm}
      loading={isPending}
    />
  );
}
